import React from 'react';
import { Link } from 'react-router-dom';
import { useAOS } from '../../hooks/useExternalLibs';
import { useLanguage } from '../../contexts/LanguageContext';

const AfterSalesService = () => {
  // Initialize external libraries using custom hooks
  useAOS();
  
  // Get translation function
  const { t } = useLanguage();

  return (
    <div className="service-details-page">
      {/* Page Title */}
      <div className="page-title dark-background" style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/assets/img/Photo-Building/eid1.JPG)` }}>
        <div className="container position-relative">
          <h1>{t('afterSalesService.pageTitle')}</h1>
          <nav className="breadcrumbs">
            <ol>
              <li><Link to="/">{t('afterSalesService.breadcrumbHome')}</Link></li>
              <li><Link to="/">{t('afterSalesService.breadcrumbServices')}</Link></li>
              <li className="current">{t('afterSalesService.breadcrumbCurrent')}</li>
            </ol>
          </nav>
        </div>
      </div>

      {/* Service Details Section */}
      <section id="service-details" className="service-details section">
        <div className="container">
          <div className="row gy-4">
            <div className="col-lg-4" data-aos="fade-up" data-aos-delay="100">
              <div className="services-list">
                <Link to="/services/custom-manufacturing">{t('afterSalesService.customManufacturing')}</Link>
                <Link to="/services/technical-support">{t('afterSalesService.technicalSupport')}</Link>
                <Link to="/services/after-sales-service" className="active">{t('afterSalesService.afterSalesService')}</Link>
                <Link to="/services/quality-assurance">{t('afterSalesService.qualityAssurance')}</Link>
                <Link to="/services/research-development">{t('afterSalesService.researchDevelopment')}</Link>
                <Link to="/services/global-supply-chain">{t('afterSalesService.globalSupplyChain')}</Link>
              </div>
            </div>
            <div className="col-lg-8" data-aos="fade-up" data-aos-delay="200">
              <div className="service-content text-center">
                <img src={`${process.env.PUBLIC_URL}/assets/img/building/building-ekk.png`} alt="After-Sales Service" className="img-fluid services-img mx-auto d-block" />
                <h3 className="text-center">{t('afterSalesService.title')}</h3>
                <p className="text-center">
                  {t('afterSalesService.description1')}
                </p>
                <p className="text-center">
                  {t('afterSalesService.description2')}
                </p>
                <h4 className="text-center">{t('afterSalesService.servicesTitle')}</h4>
                <ul className="text-start">
                  {t('afterSalesService.services').map((service, index) => (
                    <li key={index}><i className="bi bi-check-circle"></i> <span>{service}</span></li>
                  ))}
                </ul>
                
                <h4 className="text-center">{t('afterSalesService.maintenanceTitle')}</h4>
                <p className="text-center">
                  {t('afterSalesService.maintenanceDescription')}
                </p>
                
                <div className="row gy-4 mt-4">
                  <div className="col-lg-6">
                    <div className="service-metric text-center">
                      <h5>{t('afterSalesService.serviceAvailability')}</h5>
                      <p>{t('afterSalesService.serviceAvailabilityDesc')}</p>
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="service-metric text-center">
                      <h5>{t('afterSalesService.responseEfficiency')}</h5>
                      <p>{t('afterSalesService.responseEfficiencyDesc')}</p>
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="service-metric text-center">
                      <h5>{t('afterSalesService.spareParts')}</h5>
                      <p>{t('afterSalesService.sparePartsDesc')}</p>
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="service-metric text-center">
                      <h5>{t('afterSalesService.customerSatisfaction')}</h5>
                      <p>{t('afterSalesService.customerSatisfactionDesc')}</p>
                    </div>
                  </div>
                </div>
                
                <h4 className="text-center">{t('afterSalesService.serviceContractsTitle')}</h4>
                <p className="text-center">
                  {t('afterSalesService.serviceContractsDescription')}
                </p>
                
                <h4 className="text-center">{t('afterSalesService.customerFeedbackTitle')}</h4>
                <p className="text-center">
                  {t('afterSalesService.customerFeedbackDescription')}
                </p>
                
                <div className="text-center">
                  <Link to="/contact" className="btn btn-primary">{t('afterSalesService.requestSupport')}</Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Related Services Section */}
      <section id="related-services" className="related-services section">
        <div className="container">
          <div className="section-title" data-aos="fade-up">
            <h2>{t('afterSalesService.relatedServicesTitle')}</h2>
            <p>{t('afterSalesService.relatedServicesDescription')}</p>
          </div>
          <div className="row gy-4">
            <div className="col-lg-4 col-md-6" data-aos="fade-up" data-aos-delay="100">
              <div className="service-item position-relative">
                <div className="icon">
                  <i className="fa-solid fa-arrow-up-from-ground-water"></i>
                </div>
                <h3>{t('afterSalesService.technicalSupport')}</h3>
                <p>{t('afterSalesService.technicalSupportDesc')}</p>
                <Link to="/services/technical-support" className="readmore stretched-link">{t('afterSalesService.readMore')} <i className="bi bi-arrow-right"></i></Link>
              </div>
            </div>
            <div className="col-lg-4 col-md-6" data-aos="fade-up" data-aos-delay="200">
              <div className="service-item position-relative">
                <div className="icon">
                  <i className="fa-solid fa-trowel-bricks"></i>
                </div>
                <h3>{t('afterSalesService.qualityAssurance')}</h3>
                <p>{t('afterSalesService.qualityAssuranceDesc')}</p>
                <Link to="/services/quality-assurance" className="readmore stretched-link">{t('afterSalesService.readMore')} <i className="bi bi-arrow-right"></i></Link>
              </div>
            </div>
            <div className="col-lg-4 col-md-6" data-aos="fade-up" data-aos-delay="300">
              <div className="service-item position-relative">
                <div className="icon">
                  <i className="fa-solid fa-arrow-up-from-ground-water"></i>
                </div>
                <h3>{t('afterSalesService.globalSupplyChain')}</h3>
                <p>{t('afterSalesService.globalSupplyChainDesc')}</p>
                <Link to="/services/global-supply-chain" className="readmore stretched-link">{t('afterSalesService.readMore')} <i className="bi bi-arrow-right"></i></Link>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default AfterSalesService;